import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../../contextApi/ContextApi';
import { ClientContext } from '../../contextApi/ClientContext';

export default function Cart({isDashboard}) {
    const {currentWebsite, connected, isBelong} = useContext(AppContext);
    const {counter, cartArr} = useContext(ClientContext);
    const nav = useNavigate();
    return (
        <div className='cart_container' >
            {((connected&&isBelong)||isDashboard) && <div className={isDashboard ? "cart_img_dashboard" : 'cart_img'} onClick={()=>{isDashboard ? alert("לחצן זה יופיע רק בתנאי שהלקוח מחובר\nתפקידו להעביר את הלקוח לעמוד התשלום") : nav(`/${currentWebsite?.settings?.domain}/payment`)}}>
                {(connected&&!isDashboard&&isBelong) && counter(cartArr)}
            </div>}
        </div>
    )
}
